import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 4,
        rowsSize: [3, 1, 3, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/13/principle/principle-2-45-person-1.svg`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/13/principle/principle-2-45-person-2.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/02/13/principle/principle-2-45-person-1.wav`,
                    text: "Person 1",
                    icon: "cis-volume-high",
                    theme: "secondary",
                    shape: "round",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/02/13/principle/principle-2-45-person-2.wav`,
                    text: "Person 2",
                    icon: "cis-volume-high",
                    theme: "secondary",
                    shape: "round",
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/13/principle/principle-2-45-person-3.svg`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/13/principle/principle-2-45-person-4.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/02/13/principle/principle-2-45-person-3.wav`,
                    text: "Person 3",
                    icon: "cis-volume-high",
                    theme: "secondary",
                    shape: "round",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/02/13/principle/principle-2-45-person-4.wav`,
                    text: "Person 4",
                    icon: "cis-volume-high",
                    theme: "secondary",
                    shape: "round",
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
